<template>
    <CoreTwoColumnsRow>
        <template #left>
            <CoreBorderWrapper
                :condensed="true"
                class="flex-grow-1 flex-shrink-1 flex-basis-55 flex space-between"
            >
                {{ $t('§eq_type.name') }}
                {{ isFieldRequired('name') }}
            </CoreBorderWrapper>
        </template>
        <template #right>
            <CoreStringInput
                :validator="v$.name"
                data-testid="eq_type_name"
                v-model="unitTypeStore.unitTypeData.name"
                placeholder="§ui.placeholder_eq_type_name"
                class="flex-grow-1 flex-shrink-1 flex-basis-45"
            />
        </template>
    </CoreTwoColumnsRow>

    <CoreTwoColumnsRow>
        <template #left>
            <CoreBorderWrapper
                :condensed="true"
                class="flex-grow-1 flex-shrink-1 flex-basis-55 flex space-between"
            >
                {{ $t('§eq_type.model_year') }}
                {{ isFieldRequired('model_year') }}
            </CoreBorderWrapper>
        </template>
        <template #right>
            <CoreStringInput
                :validator="v$.model_year"
                v-model="unitTypeStore.unitTypeData.model_year"
                :placeholder="$t('§eq_type.model_year')"
                class="flex-grow-1 flex-shrink-1 flex-basis-45"
            />
        </template>
    </CoreTwoColumnsRow>

    <CoreTwoColumnsRow>
        <template #left>
            <CoreBorderWrapper
                :condensed="true"
                class="flex-grow-1 flex-shrink-1 flex-basis-55 flex space-between"
            >
                <div class="flex-1">
                    {{ $t('§eq_type.is_stationary') }}
                    {{ isFieldRequired('is_stationary') }}
                </div>
                <CoreIcon
                    name="information-outline"
                    size="18"
                    class="ml-auto"
                    fillColor="var(--color-secondary-200)"
                    v-tooltip="{ value: $t('§eq_type.is_stationary_tooltip') }"
                />
            </CoreBorderWrapper>
        </template>
        <template #right>
            <CoreBorderWrapper
                :condensed="true"
                :noBorder="true"
                class="flex-grow-1 flex-shrink-1 flex-basis-45 flex justify-center"
            >
                <CoreSelectButton
                    :validator="v$.is_stationary"
                    v-model="unitTypeStore.unitTypeData.is_stationary"
                    :options="isStationaryOptions"
                />
            </CoreBorderWrapper>
        </template>
    </CoreTwoColumnsRow>

    <CoreTwoColumnsRow>
        <template #left>
            <CoreBorderWrapper
                :condensed="true"
                class="flex-grow-1 flex-shrink-1 flex-basis-55 flex space-between"
            >
                <div class="flex-1">
                    {{ $t('§eq_type.customization_degree') }}
                    {{ isFieldRequired('customization_degree') }}
                </div>
                <CoreIcon
                    name="information-outline"
                    size="18"
                    class="ml-auto"
                    fillColor="var(--color-secondary-200)"
                    v-tooltip="{ value: $t('§eq_type.customization_degree_tooltip') }"
                />
            </CoreBorderWrapper>
        </template>
        <template #right>
            <CoreDropdown
                :validator="v$.customization_degree"
                v-model="unitTypeStore.unitTypeData.customization_degree"
                :options="optionsStore.customizationDegreeOptions"
                :sort="false"
                :placeholder="$t('§ui.placeholder_select_customization_degree')"
                class="flex-grow-1 flex-shrink-1 flex-basis-45"
            />
        </template>
    </CoreTwoColumnsRow>

</template>

<script>
import { useVuelidate } from '@vuelidate/core'

import { useUnitTypeStore } from '@/stores/unitType'
import { useOptionsStore } from '@/stores/options'
import { useUserStore } from '@/stores/user'
import rules from '../validationRules.js'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreSlider from '@/components/core/CoreSlider.vue'
import CoreDropdown from '@/components/core/CoreDropdown.vue'
import CoreSelectButton from '@/components/core/CoreSelectButton.vue'
import CoreIcon from '@/components/core/CoreIcon.vue'

export default {
    name: 'InputsBasicInfo',

    components: {
        CoreStringInput,
        CoreTwoColumnsRow,
        CoreBorderWrapper,
        CoreSlider,
        CoreDropdown,
        CoreSelectButton,
        CoreIcon,
    },

    data() {
        return {
            v$: {},
            unitTypeStore: useUnitTypeStore(),
            optionsStore: useOptionsStore(),
            userStore: useUserStore(),
        }
    },

    computed: {
        isValid() {
            return (
                !this.v$.name?.$invalid &&
                !this.v$.model_year?.$invalid &&
                !this.v$.is_stationary?.$invalid &&
                !this.v$.customization_degree?.$invalid
            )
        },

        isStationaryOptions() {
            return [
                { value: 1, label: this.$t('§ui_button.stationary') },
                { value: 0, label: this.$t('§ui_button.movable') },
            ]
        },
    },

    watch: {
        isValid: {
            handler(newValue) {
                this.unitTypeStore.isValidBasicInfo = newValue
            },
            immediate: true,
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.v$ = useVuelidate(rules, this.unitTypeStore.unitTypeData)

            if (this.$refs.nameInput && typeof this.$refs.nameInput.focus === 'function') {
                this.$refs.nameInput.focus()
            }
        })
    },
}
</script>
